import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api/client";

const Stat = ({ label, value }) => (
  <div
    className="card"
    style={{
      padding: 20,
    }}
  >
    <div
      className="muted"
      style={{
        fontSize: 11,
        textTransform: "uppercase",
        letterSpacing: ".08em",
      }}
    >
      {label}
    </div>

    <div
      className="tabular"
      style={{
        fontSize: 24,
        fontWeight: 800,
        marginTop: 4,
      }}
    >
      {value !== null &&
      value !== undefined &&
      value !== ""
        ? value
        : "—"}
    </div>
  </div>
);

function formatBalance(value, currency, locale) {
  if (
    value === null ||
    value === undefined ||
    value === ""
  ) {
    return null;
  }

  const amount = Number(value);

  if (!Number.isFinite(amount)) {
    return null;
  }

  return `${currency} ${amount.toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    async function loadStats() {
      try {
        const response = await api.get(
          "/admin/stats"
        );

        if (active) {
          setStats(response.data);
        }
      } catch (error) {
        console.error(
          "Unable to load admin statistics:",
          error
        );
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    }

    loadStats();

    return () => {
      active = false;
    };
  }, []);

  return (
    <div>
      <h1>Overview</h1>

      {stats && stats.review > 0 && (
        <Link
          to="/admin/review"
          className="alert bad"
          style={{
            display: "block",
            marginBottom: 24,
          }}
        >
          <strong>
            {stats.review} orders need review
          </strong>

          <div className="small">
            Timed-out or partially delivered.
            Check the provider before refunding.
          </div>
        </Link>
      )}

      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit, minmax(180px, 1fr))",
          gap: 16,
        }}
      >
        <Stat
          label="Orders today"
          value={
            loading
              ? "Loading..."
              : stats?.ordersToday
          }
        />

        <Stat
          label="Revenue today"
          value={
            loading
              ? "Loading..."
              : stats?.revenueToday !== undefined
                ? `₹${Number(
                    stats.revenueToday
                  ).toLocaleString("en-IN")}`
                : null
          }
        />

        <Stat
          label="Users"
          value={
            loading
              ? "Loading..."
              : stats?.users !== undefined
                ? Number(
                    stats.users
                  ).toLocaleString("en-IN")
                : null
          }
        />

        <Stat
          label="Smile BR balance"
          value={
            loading
              ? "Loading..."
              : formatBalance(
                  stats?.smileBrBalance,
                  "R$",
                  "pt-BR"
                )
          }
        />

        <Stat
          label="Smile PH balance"
          value={
            loading
              ? "Loading..."
              : formatBalance(
                  stats?.smilePhBalance,
                  "₱",
                  "en-PH"
                )
          }
        />

        <Stat
          label="Yokcash balance"
          value={
            loading
              ? "Loading..."
              : stats?.yokcashSaldo !== null &&
                  stats?.yokcashSaldo !==
                    undefined
                ? `Rp ${Number(
                    stats.yokcashSaldo
                  ).toLocaleString("id-ID")}`
                : null
          }
        />
      </div>
    </div>
  );
}